import { Inject, Injectable } from '@angular/core';

import { Actions, ofType, createEffect } from '@ngrx/effects';

import * as mappingAction from '../actions/mapping.action';

import { ApiService } from '@usimweb/core/services';
import { catchError, map, of, switchMap } from 'rxjs';

import { MatSnackBar } from '@angular/material/snack-bar';
import { Env, Mapped } from '@usimweb/core/models';

@Injectable()
export class MappingEffects {
  constructor(@Inject('environment') private environment: Env, private actions$: Actions, private apiService: ApiService, private snackBar: MatSnackBar) {}

  private DEBUG_TIME: number = this.environment.production === true ? 0 : 1000;

  $loadMapping = createEffect(() => {
    return this.actions$.pipe(
      ofType(mappingAction.LOAD_MAPPING),
      map((action: mappingAction.LoadMapping) => action.payload),
      switchMap((uuid) => {
        return this.apiService.getMappingToken(uuid).pipe(
          map((mapped: Mapped) => new mappingAction.LoadMappingSuccess(mapped)),
          catchError((error) => of(new mappingAction.LoadMappingFail(error)))
        );
      })
    );
  });

  // $loadMasterModel = createEffect(() => {
  //   return this.actions$.pipe(
  //     ofType(mappingAction.LOAD_MAPPING),
  //     map((action: mappingAction.LoadMapping) => action.payload),
  //     switchMap((uuid) => {
  //       return this.apiService.getMasterModels(models).pipe(
  //         map((mapped: Mapped) => new mappingAction.LoadMappingSuccess(mapped)),
  //         catchError((error) => of(new mappingAction.LoadMappingFail(error)))
  //       );
  //     })
  //   );
  // });
}
